var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 1H5C4.44772 1 4 1.44772 4 2H8C8 1.44772 7.55228 1 7 1ZM9 2C9 0.895431 8.10457 0 7 0H5C3.89543 0 3 0.895431 3 2H2H1H0.5C0.223858 2 0 2.22386 0 2.5C0 2.77614 0.223858 3 0.5 3H1V11C1 12.1046 1.89543 13 3 13H9C10.1046 13 11 12.1046 11 11V3H11.5C11.7761 3 12 2.77614 12 2.5C12 2.22386 11.7761 2 11.5 2H11H10H9ZM10 3H9H8H4H3H2V11C2 11.5523 2.44772 12 3 12H9C9.55228 12 10 11.5523 10 11V3ZM4 10L4 6H5V10H4ZM7 6V10H8V6H7Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBin);
export default __webpack_public_path__ + "static/media/bin.ffec5e78567adefbe175d717ca8146e5.svg";
export { ForwardRef as ReactComponent };